import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { isMobileWorkingEnabled } from "../../../functions/isMobileWorkingEnabled.function";
import { useRemoteFetchMetadata } from "../../../hooks/Remote/Metadata/useRemoteFetchMetadata";

/** Company-level mobile working flag (same source as legacy dashboard TopList). */
export function useDashboard2MobileWorkingEnabled(): boolean {
  const userProfile = useSelector((state: RootState) => state.login.userInformation);
  const { data: metadata } = useRemoteFetchMetadata();

  return isMobileWorkingEnabled(metadata, userProfile);
}
